import { Check } from "lucide-react"

const plans = [
  {
    name: "Starter",
    price: "₦5,000",
    period: "/month",
    description: "Perfect for solo entrepreneurs and small startups",
    features: ["1 Business", "Basic Dashboard", "Invoice Management", "Expense Tracking", "Email Support"],
    popular: false,
  },
  {
    name: "Professional",
    price: "₦10,000",
    period: "/month",
    description: "Ideal for growing businesses with multiple entities",
    features: [
      "Up to 5 Businesses",
      "Advanced Dashboard",
      "Team Collaboration",
      "Bank Integration",
      "Automated Reports",
      "Priority Support",
    ],
    popular: true,
  },
  {
    name: "Enterprise",
    price: "₦20,000",
    period: "/month",
    description: "For established businesses with complex needs",
    features: [
      "Unlimited Businesses",
      "Custom Integrations",
      "Advanced Security",
      "Dedicated Account Manager",
      "Custom Reports",
      "24/7 Phone Support",
    ],
    popular: false,
  },
]

export default function Pricing() {
  return (
    <section id="pricing" className="relative overflow-hidden py-20 bg-white dark:bg-gradient-to-br dark:from-slate-800 dark:via-slate-900 dark:to-slate-800">
      <div className="pointer-events-none absolute inset-0 dark:block hidden">
        <div className="absolute top-10 -left-24 h-72 w-72 rounded-full bg-cyan-400/10 blur-3xl"></div>
        <div className="absolute bottom-0 -right-16 h-80 w-80 rounded-full bg-blue-400/10 blur-3xl"></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center space-y-4 mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 dark:text-white">Simple, transparent pricing</h2>
          <p className="text-xl text-gray-600 dark:text-gray-400">
            Choose the plan that fits your business needs. All plans include a 14-day free trial.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {plans.map((plan, index) => (
            <div
              key={index}
              className={`relative p-8 rounded-2xl border-2 ${
                plan.popular ? "border-blue-500 bg-blue-50 dark:bg-blue-900/20" : "border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800"
              }`}
            >
              {plan.popular && (
                <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
                  <span className="bg-blue-600 text-white px-4 py-2 rounded-full text-sm font-medium">
                    Most Popular
                  </span>
                </div>
              )}

              <div className="text-center mb-8">
                <h3 className="text-2xl font-bold text-gray-900 dark:text-white mb-2">{plan.name}</h3>
                <p className="text-gray-600 dark:text-gray-400 mb-4">{plan.description}</p>
                <div className="flex items-baseline justify-center">
                  <span className="text-4xl font-bold text-gray-900 dark:text-white">{plan.price}</span>
                  <span className="text-gray-600 dark:text-gray-400 ml-1">{plan.period}</span>
                </div>
              </div>

              <ul className="space-y-4 mb-8">
                {plan.features.map((feature, featureIndex) => (
                  <li key={featureIndex} className="flex items-center">
                    <Check className="h-5 w-5 text-green-500 mr-3" />
                    <span className="text-gray-700 dark:text-gray-300">{feature}</span>
                  </li>
                ))}
              </ul>

              <button
                className={`w-full py-3 px-6 rounded-lg font-medium transition-colors ${
                  plan.popular
                    ? "bg-blue-600 text-white hover:bg-blue-700"
                    : "bg-gray-100 dark:bg-gray-700 text-gray-900 dark:text-white hover:bg-gray-200 dark:hover:bg-gray-600"
                }`}
              >
                Start Free Trial
              </button>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
